import { useTranslation } from "react-i18next";
import { useGetClass } from "@packages/api/madlenAPI";

interface StudentListProps {
  classId: string;
}

export function StudentList({ classId }: StudentListProps) {
  const { t } = useTranslation();

  const { data: classData, isLoading } = useGetClass(classId);

  if (isLoading) {
    return (
      <div className="mt-2 space-y-1 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
        <div className="px-2 py-1 text-sm text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/50 rounded animate-pulse">
          {t("common.loading")}
        </div>
      </div>
    );
  }

  if (!classData?.students?.length) {
    return (
      <div className="mt-2 space-y-1 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
        <div className="px-2 py-1 text-sm text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/50 rounded">
          {t("classes.noStudents")}
        </div>
      </div>
    );
  }

  return (
    <div className="mt-2 space-y-1 max-h-32 overflow-y-auto scrollbar-thin scrollbar-thumb-gray-300 dark:scrollbar-thumb-gray-600">
      {classData.students.map((student) => (
        <div
          key={student.id}
          className="px-2 py-1 text-sm text-gray-600 dark:text-gray-300 bg-gray-50 dark:bg-gray-700/50 rounded"
        >
          {student.display_name}
        </div>
      ))}
    </div>
  );
}
